'use client';

import { WatchlistMix } from '../WatchlistMix';
import { WatchlistMixConfig } from '../utils';
import { WatchlistStats } from '../WatchlistPerformance/processors';
import { Performers } from './Performers';

interface InsightsSnapshotProps {
  stats: WatchlistStats;
  pieConfigs: WatchlistMixConfig[];
  isCryptoOnly: boolean;
  isLoadingMix: boolean;
}

export const InsightsSnapshot = ({
  stats,
  pieConfigs,
  isCryptoOnly,
  isLoadingMix,
}: InsightsSnapshotProps) => {
  const hasPerformers = Boolean(stats.best_ticker || stats.worst_ticker);
  const hasMix = !isCryptoOnly && (isLoadingMix || pieConfigs.length > 0);

  if (!hasPerformers && !hasMix) return null;

  return (
    <section className="border-t border-white/10 bg-bzblue-800 text-white">
      <div className="flex items-center justify-between border-b border-white/10 px-4 py-2.5">
        <h3 className="text-sm font-bold text-white">Watchlist snapshot</h3>
        <span className="text-xs font-medium text-white/70">{stats.count} symbols</span>
      </div>
      <div
        className={`grid gap-px bg-white/10 ${
          isCryptoOnly ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4'
        }`}
      >
        <Performers stats={stats} />
        {!isCryptoOnly && <WatchlistMix configs={pieConfigs} isLoading={isLoadingMix} variant="cell" />}
      </div>
    </section>
  );
};
